//-----------------对数字进行处理--------------


//字符串截取,每三位加逗号

export const thousands = function (num) {
  // console.log(num)
  var n = Number(num);
  if (!isNaN(n)) {
    num = Math.floor(num * 100) / 100;
    var str = num.toString();
    var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
    return str.replace(reg, "$1,");
  } else {
    return num;
  }
}


//字符串截取,每三位加逗号 (上传页面)
export const thousands1 = function (num) {
  var n = Number(num);
  if (!isNaN(n) && num) {
    var str = num.toString();
    var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
    return str.replace(reg, "$1,");
  } else {
    return num;
  }
}
// (money, precision = 2, splitDesc = ',') => {
//   precision = +precision // 这里为了处理precision传入null  +null=0
//   const str = money.toFixed(precision)
//   const reg = str.indexOf('.') > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g
//   return str.replace(reg, '$1,')
// }



//生成uuid
export const uuid = function () {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}

//获取前n天日期
export const getBeforeDate = function (n) {
  var s;
  var n = n;
  var d = new Date();
  var year = d.getFullYear();
  var mon = d.getMonth() + 1;
  var day = d.getDate();
  if (day <= n) {
    if (mon > 1) {
      mon = mon - 1;
    } else {
      year = year - 1;
      mon = 12;
    }
  }
  d.setDate(d.getDate() - n);
  year = d.getFullYear();
  mon = d.getMonth() + 1;
  day = d.getDate();
  s = year + "-" + (mon < 10 ? ('0' + mon) : mon) + "-" + (day < 10 ? ('0' + day) : day);
  return s;
}

//获取去年同期
export const getLastYear = function (date) {
  var d = new Date(date);
  var year = d.getFullYear() - 1;
  var mon = d.getMonth() + 1;
  var day = d.getDate();
  var s = year + '-' + (mon < 10 ? '0' + mon : mon) + '-' + (day < 10 ? '0' + day : day);
  return s;
}

//获取当前月份
export const getCurrentMouth = function () {
  var s;
  var d = new Date();
  var year = d.getFullYear();
  var mon = d.getMonth() + 1;
  s = year + "-" + (mon < 10 ? ('0' + mon) : mon);
  return s;
}

//数组扁平化
export const flatten = function (arr) {
  var res = [];
  arr.map(item => {
    if (Array.isArray(item)) {
      res = res.concat(flatten(item));
    } else {
      res.push(item);
    }
  });
  return res;
}

export const excludeSpecial = function (s) {
  let containSpecial = RegExp(/[(\ )(\~)(\!)(\@)(\#)(\$)(\%)(\^)(\&)(\*)(\()(\))(\-)(\_)(\+)(\=)(\[)(\])(\{)(\})(\|)(\\)(\;)(\:)(\')(\")(\,)(\.)(\/)(\<)(\>)(\?)(\)]+/);

  return containSpecial.test(s);
};

// 获取当月第一天
export function getDate() {
  var myDate = new Date();
  var tYear = myDate.getFullYear()
  var tMonth = myDate.getMonth()

  if ((tMonth + 1).toString().length == 1) {
    tMonth = "0" + (tMonth + 1);
  }
  return tYear + "-" + tMonth + "-01"
}




//文件下载
//fileName 下载文件名
//blobType 文件类型
//fileData 流文件
export const downloadFile = function ({ fileName, blobType, fileData } = {
  fileName: 'excel.xlsx',
  blobType: 'application/vnd.ms-excel'
}) {
  const blob = new Blob([fileData], { type: blobType });//处理文档流
  const elink = document.createElement('a');
  elink.download = fileName;
  elink.style.display = 'none';
  elink.href = URL.createObjectURL(blob);
  document.body.appendChild(elink);
  elink.click();
  URL.revokeObjectURL(elink.href);
  document.body.removeChild(elink);
}


// 级联去底层空数据
export function getTreeData(data, key) {
  // 循环遍历json数据
  for (var i = 0, length = data.length; i < length; i++) {
    if (data[i][key] instanceof Array) {
      var _length = data[i][key].length
      if (_length < 1) {
        // children若为空数组，则将children设为undefined
        data[i][key] = undefined;
      } else {
        // children若不为空数组，则继续 递归调用 本方法
        getTreeData(data[i][key], key);
      }
    }
  }
  return data;
}

// date 代表指定的日期，格式：2018-09-27
// day 传-1表始前一天，传1表始后一天
// JS获取指定日期的前一天，后一天
export function getNextDate(date, day) {
  var dd = new Date(date);
  dd.setDate(dd.getDate() + day);
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
  var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
  return y + "-" + m + "-" + d;
};

//日期格式化
//案例 let date = new Date()
// dateFormat("YYYY-mm-dd HH:MM", date)
// >>> 2019-06-06 19:45`
export function dateFormat(fmt, date) {
  let ret;
  let opt = {
    "Y+": date.getFullYear().toString(),        // 年
    "m+": (date.getMonth() + 1).toString(),     // 月
    "d+": date.getDate().toString(),            // 日
    "H+": date.getHours().toString(),           // 时
    "M+": date.getMinutes().toString(),         // 分
    "S+": date.getSeconds().toString()          // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
    }
    ;
  }
  ;
  return fmt;
}

/**
 * 计算两个日期之间的天数
 * @param dateString1  开始日期 yyyy-MM-dd
 * @param dateString2  结束日期 yyyy-MM-dd
 * @returns {number} 如果日期相同 返回一天 开始日期大于结束日期，返回0
 */
export function getDaysBetween(dateString1, dateString2) {
  var startDate = Date.parse(dateString1);
  var endDate = Date.parse(dateString2);
  if (startDate > endDate) {
    return 0;
  }
  if (startDate == endDate) {
    return 1;
  }
  var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
  return days;
}
// 获取字符串的字节长度
export function getLen(v) {
  if (typeof (v) == 'string') {
    var regEx = /^[\u4e00-\u9fa5\uf900-\ufa2d]+$/;
    if (regEx.test(v)) {
      return v.length * 2;
    } else {
      var oMatches = v.match(/[\x00-\xff]/g);
      var oLength = v.length * 2 - oMatches.length;
      return oLength;
    }
  }
}


export function getEffectInfo(data, field) {
  api.getEffectInfo(data).then(res => {
    if (res.data.code === 200) {

      this[field] = res.data.data
    }
  }).catch((res) => {
    console.error(res)
  })
}

/**
 * 格式化时间
 * @param {[object Date]} date
 * @returns {string} 返回 xxxx-xx-xx格式的日期
 */
export function formatDate(date) {
  if (date.length <= 10) {
    return date
  } else {
    if (Object.prototype.toString.call(date) !== '[object Date]') {
      throw new Error('format error! Expected an instance of Date object ')
    }
    const year = date.getFullYear()
    const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

    return `${year}-${month}-${day}`
  }
}
// 格式时间 "2021-04-29T07:19:45.000+0000"
export function dateFormatting(date) {
  // console.log(date)
  if (date) {
    if (date.indexOf('T') !== -1) {
      let arr = date.split('T')
      let time = arr[1].substr(0, 8)
      let t = arr[0] + ' ' + time
      return t
    }



  } else {
    return date
  }

}
// 图片转base64
export function getBase64(file) {
  return new Promise(function (resolve, reject) {
    let reader = new FileReader();
    let imgResult = "";
    reader.readAsDataURL(file);
    reader.onload = function () {
      imgResult = reader.result;
    };
    reader.onerror = function (error) {
      reject(error);
    };
    reader.onloadend = function () {
      resolve(imgResult);
    };
  });
}

// 获取日期
export function setDay(day) {
  // console.log(day,'day------')
  const myDate = new Date()
  myDate.setTime(myDate.getTime() - 24 * 60 * 60 * 1000)
  const s = myDate.getFullYear() + '-' + ((myDate.getMonth() + 1) > 10 ? (myDate.getMonth() + 1) : '0' + (myDate.getMonth() + 1)) + '-' + (myDate.getDate() > 10 ? myDate.getDate() : '0' + myDate.getDate())
  const end = s
  const lw = new Date(myDate - 1000 * 60 * 60 * 24 * (-day - 1))
  const lastY = lw.getFullYear()
  const lastM = lw.getMonth() + 1
  const lastD = lw.getDate()
  const start = lastY + '-' + (lastM < 10 ? '0' + lastM : lastM) + '-' + (lastD < 10 ? '0' + lastD : lastD)
  return start
};
// 获取相差时间
export function DateDifference(faultDate, completeTime) {
  var stime = new Date(faultDate).getTime();
  var etime = new Date(completeTime).getTime();
  var usedTime = etime - stime;  //两个时间戳相差的毫秒数
  var days = Math.floor(usedTime / (24 * 3600 * 1000));
  //计算出小时数
  var leave1 = usedTime % (24 * 3600 * 1000);    //计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000));
  //计算相差分钟数
  var leave2 = leave1 % (3600 * 1000);        //计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000));
  // var time = days + "天"+hours+"时"+minutes+"分";
  var time = days;
  return time;
};

// 将_改成驼峰
export function ToHump(name) {
  if (name.includes("_")) {
    let oarr = name.split("_");
    for (let i = 1; i < oarr.length; i++) {
      oarr[i] = oarr[i].charAt(0).toUpperCase() + oarr[i].slice(1);
    }
    return oarr.join("");
  }
  return name;
};
// 将驼峰转变成 _
export function transformName(name) {
  let copyName = name.toLowerCase();
  let index = 0;
  let str = '';
  while (index != name.length) {
    if (copyName[index] !== name[index]) {
      str = str + '_' + copyName[index];
    } else {
      str += copyName[index];
    }
    index++;
  }
  return str;
};

// 时间格式化
export function dateFormat1(format, date = new Date()) {
  // yyyy-MM-dd hh:mm:ss
  if (!(date instanceof Date)) throw new TypeError('date must be a Date')
  const timeObj = {
    yyyy: date.getFullYear(),
    MM: date.getMonth() + 1,
    M: date.getMonth() + 1,
    dd: date.getDate(),
    d: date.getDate(),
    hh: date.getHours(),
    mm: date.getMinutes(),
    ss: date.getSeconds(),
    SSS: date.getMilliseconds()
  }
  const padOptions = {
    MM: 2,
    dd: 2,
    hh: 2,
    mm: 2,
    ss: 2,
    SSS: 3
  }
  Object.keys(timeObj).forEach(key => {
    const option = padOptions[key]
    if (option) {
      timeObj[key] = String(timeObj[key]).padStart(option, '0')
    }
    format = format.replace(key, timeObj[key])
  })
  return format
}

export const deepClode = (obj, cache = []) => {
  if (obj === null || typeof obj != 'object') {
    return obj
  }
  if (Object.prototype.toString.call(obj) === '[object Date]') return new Date(obj)
  if (Object.prototype.toString.call(obj) === '[object RegExp]') return new RegExp(obj)
  if (Object.prototype.toString.call(obj) === '[object Error]') return new Error(obj)
  let item = cache.filter(item => item.origin === obj)[0]
  if (item) return item.newObj
  let newObj = Array.isArray(obj) ? [] : {}
  cache.push({
    origin: obj,
    newObj
  })
  Object.keys(obj).forEach(key => {
    if (typeof obj[key] == "object") {
      newObj[key] = deepClode(obj[key], cache)
    } else {
      newObj[key] = obj[key]
    }
  });
  return newObj
}




// WEBPACK FOOTER //
// ./src/utils/tool.js